import React from 'react';
import { ArrowDownLeftIcon, ArrowUpRightIcon } from 'lucide-react';
import type { SyncLogEntry } from '../../types/docmagic';
import { formatDateTime } from '../../utils/datetime';
function statusTone(status: number): string {
  if (status === 0 || status >= 500) return 'bg-[#fdeded] text-error';
  if (status >= 400) return 'bg-[#fef5e6] text-warning';
  if (status === 201) return 'bg-[#ebf7e6] text-success';
  return 'bg-canvas text-ink';
}
export function SyncLog({
  logs
}: {
  logs: SyncLogEntry[];
}) {
  return <section aria-labelledby="log-heading" className="rounded border border-line" data-id="element-60" data-mp="27fwomhjl34sr">
      <div className="border-b border-line px-4 py-3" data-id="element-61" data-mp="2m5vlmgzeka6n">
        <h3 id="log-heading" className="text-sm font-bold text-ink" data-id="element-62" data-mp="2m7ezy21i0b5s">Integration Log</h3>
        <p className="text-xs text-muted" data-id="element-63" data-mp="2h8lyj7zhkalz">DocMagic request and response activity</p>
      </div>
      <ol className="max-h-80 divide-y divide-line overflow-y-auto" data-id="element-64" data-mp="2v6k2rkk3eqnr">
        {logs.map(log => <li key={log.id} className="px-4 py-2.5" data-id="element-65" data-mp="2q54dtheso003">
            <div className="flex items-center gap-2" data-id="element-66" data-mp="38owlsvy3t9j8">
              {log.direction === 'Inbound' ? <ArrowDownLeftIcon className="h-3.5 w-3.5 text-muted" aria-label="Inbound" data-id="element-67" data-mp="3do96ba1i64in" /> : <ArrowUpRightIcon className="h-3.5 w-3.5 text-muted" aria-label="Outbound" data-id="element-68" data-mp="3ilhrzklv0qon" />}
              <span className="font-mono text-[11px] font-semibold text-muted" data-id="element-69" data-mp="3nmyqj9gvg122">{log.method}</span>
              <span className={`rounded px-1.5 font-mono text-[11px] font-semibold ${statusTone(log.status)}`} data-id="element-70" data-mp="3rmfw02wasy78">
                {log.status === 0 ? 'TIMEOUT' : log.status}
              </span>
              <time dateTime={log.at} className="ml-auto text-[11px] text-muted" data-id="element-71" data-mp="58pg6jw4p27t">{formatDateTime(log.at)}</time>
            </div>
            <p className="mt-1 text-sm text-ink" data-id="element-72" data-mp="a8k5ij099jqr">{log.note}</p>
            <p className="truncate font-mono text-[11px] text-muted" data-id="element-73" data-mp="f6vhp0e0w6c5">{log.endpoint}</p>
          </li>)}
      </ol>
    </section>;
}